import {
  AICG_SHOW_INIT,
  AICG_SHOW_DILOG,
  AICG_GET_QUESTION_SUCCESS,
  AICG_GET_REPLYS_SUCCESS,
  AICG_ADD_ZAN_DAO,
  AICG_REPLYS_ADD_REPLY,
  AICG_CLEAR_LIST,
  AICG_ADD_DOWNLOAD,
  AICG_REPLY_COMMAND_END,
  AICG_REPLY_WRITING_END,
  AICG_REPLY_WRITING_STOP,
  AICG_REPLY_IS_BUSING,
  AICG_SHOW_MESSAGE,
  AICG_SAVE_PREV_CONTEXT,
} from '../constants/aigc';

const initState = {
  showInit: false,
  showDialog: {
    show: false,
  },
  // 相关推荐问题
  aigcRecoQuestion: {},
  // 当前聊天渲染列表
  aigcReplyList: [],
  // 当前AI回答
  aigcReplys: {},
  // 当前用户问题
  aigcUserText: {},
  // 0: 正常状态,  1: 请求数据中  2: 请求完成  3: 打字中  4; 打字暂停   5: 打字完成
  isBusing: 0,
  aigcMessage: {
    isShow: false,
  },
  // 当前AI回答
  aigcIsChangeReply: {},
};

const aigc = (state = initState, action = {}) => {
  let aigcReplyList = [...state?.aigcReplyList];
  switch (action.type) {
    case AICG_SHOW_INIT:
      return { ...state, showInit: action.data };
    case AICG_SHOW_DILOG:
      return { ...state, showDialog: action.data };
    case AICG_GET_QUESTION_SUCCESS:
      return { ...state, aigcRecoQuestion: action.data };
    case AICG_GET_REPLYS_SUCCESS:
      try {
        // 添加一个问题。
        if (action?.data && action?.data?.chatType === 'usertext') {
          let newUserText = {
            writing: 1,
            ...action.data,
          };
          aigcReplyList.push(newUserText);

          return { ...state, aigcReplyList, aigcUserText: newUserText };
        }
        // 处理普通回答
        if (
          action?.data &&
          action?.data?.replys?.length > 0 &&
          action?.data?.chatType === 'reply' &&
          action?.data?.isReAnswer === false
        ) {
          // let h5IDAll = +new Date();
          // action?.data?.replys.forEach((item, i) => {
          //   if (['-2', '-1', '0', '1', '2', '3', '4'].indexOf(item.commandCode) > -1) {
          //     let h5ID = +new Date() + i;
          //     let writing = 2; // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
          //     let newReply = {
          //       h5IDAll: h5IDAll, //
          //       chatType: 'reply',
          //       userQuestion: action?.data?.userQuestion,
          //       replys: [
          //         {
          //           ...item,
          //           h5ID: h5ID, //
          //           writing: writing,
          //           context: action?.data?.context,
          //           question: action?.data?.question,
          //         },
          //       ],
          //     };
          //     aigcReplyList.push(newReply);
          //   }
          // });

          let aigcReplysNew = { ...action.data, isCommandEnd: false };
          return { ...state, aigcReplys: aigcReplysNew };
        }

        // 处理重新回答 的正在回答
        if (
          action?.data &&
          action?.data?.chatType === 'reply' &&
          action?.data?.isReAnswering === 1 && // 1: 正在请求重新回答  2: 重新回答请求成功
          action?.data?.isReAnswer &&
          action?.data?.reAnswer &&
          action?.data?.reAnswer?.h5IDAll
        ) {
          let oldReplys = aigcReplyList[aigcReplyList.length - 1];
          oldReplys.replys.push({});
          aigcReplyList.splice(aigcReplyList.length - 1, 1, oldReplys);
          return { ...state, aigcReplyList };
        }
        // 处理重新回答
        if (
          action?.data &&
          action?.data?.replys &&
          action?.data?.replys?.length > 0 &&
          action?.data?.chatType === 'reply' &&
          action?.data?.isReAnswering === 2 && // 1: 正在请求重新回答  2: 重新回答请求成功
          action?.data?.isReAnswer === true &&
          action?.data?.reAnswer &&
          action?.data?.reAnswer?.h5IDAll
        ) {
          let h5ID = +new Date();
          let oldReplys = aigcReplyList[aigcReplyList.length - 1];
          let newReply = {
            ...(action?.data?.replys[0] || {}),
            h5ID: h5ID, //
            writing: 2, // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
            context: action?.data?.context, //
            question: action?.data?.question, //
          };
          oldReplys.replys.splice(oldReplys.replys.length - 1, 1, newReply);

          aigcReplyList.splice(aigcReplyList.length - 1, 1, oldReplys);
          let aigcReplysNew = { ...action.data, isCommandEnd: false };
          return { ...state, aigcReplyList, aigcReplys: aigcReplysNew };
        }

        // 请求错误的处理
        if (action?.data && action?.data?.chatType === 'reply' && action?.data?.isError === true) {
          aigcReplyList.push(action?.data);
          let aigcReplysNew = { ...action.data, isCommandEnd: false };
          return { ...state, aigcReplyList, aigcReplys: aigcReplysNew };
        }

        return { ...state, aigcReplys: { ...action.data, isCommandEnd: false } };
      } catch (error) {
        return { ...state };
      }
    case AICG_ADD_ZAN_DAO:
      try {
        let found = null;
        let index = null;
        if (action.data && action.data.h5IDAll) {
          aigcReplyList.forEach((item, i) => {
            if (item.h5IDAll === action.data.h5IDAll) {
              found = { ...item };
              index = i;
            }
          });
          if (found && index !== null && found?.replys?.length > 0) {
            let found_r = null;
            let index_r = null;
            found.replys.forEach((itemR, j) => {
              if (itemR.h5ID === action.data.h5ID) {
                found_r = { ...itemR };
                index_r = j;
              }
            });
            if (found_r && index_r !== null) {
              found_r.isZan = action.data.isZan || false;
              found_r.isDao = action.data.isDao || false;
              found.replys.splice(index_r, 1, found_r);
              aigcReplyList.splice(index, 1, found);
            }
          }
        }
        return { ...state, aigcReplyList: aigcReplyList };
      } catch (error) {
        return { ...state };
      }

    case AICG_REPLYS_ADD_REPLY:
      aigcReplyList.push(action.data);
      return {
        ...state,
        aigcReplyList: aigcReplyList,
        aigcReplys: { ...state?.aigcReplys, isCommandEnd: true },
      };

    case AICG_CLEAR_LIST:
      return { ...state, aigcReplyList: [], aigcReplys: {} };
    case AICG_ADD_DOWNLOAD:
      // 添加下载任务后的处理
      try {
        let h5IDAll = +new Date();
        let h5ID = +new Date();
        let textInfo = '';
        if (action?.data?.softInfo && action?.data?.softInfo?.softName) {
          if (
            action.data.softInfo.isUpdate &&
            action.data.softInfo.versionOld &&
            action.data.softInfo.versionNew
          ) {
            textInfo = `${action.data.softInfo.softName}将从${action.data.softInfo.versionOld}版本更新到${action.data.softInfo.versionNew}版本，已为您添加到下载任务中。`;
          } else {
            textInfo = `${action.data.softInfo.softName}已经添加到下载任务中。`;
          }
        }
        let newReply = {
          h5IDAll: h5IDAll, //
          chatType: 'reply',
          userQuestion: {
            userText: action?.data?.usertext || '',
          },
          replys: [
            {
              h5ID: h5ID, //
              writing: 2, // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
              commandCode: '1001',
              commandId: '1001',
              commandMsg: {
                appList: [{ ...action?.data?.softInfo }],
                tip: textInfo,
                title: '',
                detailInfo: '',
              },
              context: action?.data?.context,
              question: '',
            },
          ],
        };
        aigcReplyList.push(newReply);
      } catch (error) {
        return { ...state };
      }
      return { ...state, aigcReplyList: aigcReplyList };
    case AICG_REPLY_COMMAND_END:
      /**
       * 处理命令完成, 添加新的回答(添加完成).
       * 解析命令是通过aigcReplys解析的。所以回传aigcReplys, 并且回传下次reply的回答信息
       */
      try {
        let h5IDAll = +new Date();
        let h5ID = +new Date();
        let newReply = {
          h5IDAll: h5IDAll, //
          chatType: 'reply',
          userQuestion: action?.data?.userQuestion ?? {},

          replys: [
            {
              h5ID: h5ID, //
              writing: 2, // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
              commandCode: action?.data?.isShowTask !== 0 ? '1001' : '1002', // 1001 添加下载任务完成, 1010接口请求错误
              commandId: '1001',
              commandMsg: {
                appList: [],
                tip: action?.data?.textInfo,
                title: '',
                detailInfo: '',
                // 用于处理下载任务中包含不可直接下载软件，添加文案(当前软件不支持下载, 你可以查看详情)说明
                errorApplist: action?.data?.errorApplist || [],
              },
              context: '',
              question: '',
            },
          ],
        };
        aigcReplyList.push(newReply);
        return {
          ...state,
          aigcReplyList: aigcReplyList,
          aigcReplys: { ...action.data, isCommandEnd: true },
        };
      } catch (error) {
        return { ...state };
      }
    case AICG_REPLY_WRITING_END:
      // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
      if (!(action?.data?.h5IDAll && action?.data?.h5ID)) {
        return { ...state };
      }
      try {
        let index = null;
        let found = null;
        //
        aigcReplyList?.forEach((item, i) => {
          if (
            item?.chatType === 'reply' &&
            item?.replys &&
            item?.replys?.length > 0 &&
            item.h5IDAll === action.data.h5IDAll
          ) {
            index = i;
            found = { ...item };
          }
        });

        if (index !== null && found && found?.replys?.length > 0) {
          let index_r = null;
          let found_r = null;
          found?.replys?.forEach((itemR, j) => {
            if (itemR.h5ID === action.data.h5ID) {
              index_r = j;
              found_r = { ...itemR };
            }
          });
          if (index_r !== null && found_r) {
            found?.replys?.splice(index_r, 1, {
              ...found_r,
              writing: 3,
            });
          }
          let found_r_n = found?.replys[index_r + 1];
          let found_n = aigcReplyList[index + 1] ? { ...aigcReplyList[index + 1] } : null;
          if (found_r_n) {
            // 多条消息时：处理一条回答中的下一条消息
            found?.replys?.splice(index_r + 1, 1, {
              ...found_r_n,
              writing: 2,
            });
            aigcReplyList.splice(index, 1, found);
          } else if (
            // 单条消息时，处理下一条消息
            found_n &&
            found_n?.replys &&
            found_n?.replys?.length > 0 &&
            found_n?.replys[0]
          ) {
            found_n.replys[0].writing = 2;
            aigcReplyList.splice(index + 1, 1, found_n);
          }
        }

        return { ...state, aigcReplyList: aigcReplyList };
      } catch (error) {
        return { ...state };
      }
    case AICG_REPLY_WRITING_STOP:
      // 点击暂停回答后的处理
      try {
        let found = null;
        let index = null;
        if (action.data && action.data.h5IDAll) {
          aigcReplyList.forEach((item, i) => {
            if (item.h5IDAll === action.data.h5IDAll) {
              found = { ...item };
              index = i;
            }
          });
          if (found && index !== null && found?.replys?.length > 0) {
            let index_r = null;
            let found_r = null;
            found?.replys?.forEach((itemR, j) => {
              if (itemR.h5ID === action.data.h5ID) {
                index_r = j;
                found_r = { ...itemR };
              }
            });
            if (index_r !== null && found_r) {
              found_r?.commandMsg?.appList?.forEach((itemSoft, index) => {
                if (
                  itemSoft &&
                  action?.data?.appList?.length > 0 &&
                  action?.data?.appList[index] &&
                  action?.data?.appList[index]?.pauseDesc
                ) {
                  itemSoft.pauseDesc = action?.data?.appList[index]?.pauseDesc;
                }
              });
              found?.replys?.splice(index_r, 1, {
                ...found_r,
                writing: 4, // 1: 不用走打字效果  2: 需要走打字效果  3: 打字效果已经走完了   4: 已暂停
              });
            }
            aigcReplyList.splice(index, 1, { ...found });
          }
        }
        return { ...state, aigcReplyList: aigcReplyList };
      } catch (error) {
        return { ...state };
      }
    case AICG_REPLY_IS_BUSING:
      // isBusing 0: 正常状态,  1: 请求数据中  2: 请求完成  3: 打字中  4; 打字暂停   5: 打字完成
      // 开始请求, 开始打字, 打字完成, 点击暂停 都会来改变这个值
      return { ...state, isBusing: action.data.isBusing };
    case AICG_SHOW_MESSAGE:
      return { ...state, aigcMessage: { ...action.data } };
    case AICG_SAVE_PREV_CONTEXT:
      return { ...state, aigcIsChangeReply: action.data };
    default:
      return state;
  }
};

export default aigc;
